"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const writeFunctionOutputToRegistry_1 = __importDefault(require("../../shared/writeFunctionOutputToRegistry"));
const valueIsArray_1 = __importDefault(require("../../typeAssertions/valueIsArray"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const buildFunctionEvaluator_1 = __importDefault(require("../buildFunctionEvaluator"));
const buildCallableCollectionFilter = (functionDefinitions) => async ({ functionId, callbacks, executeProcesses, lastFunctionsOutputs, entryVars: { collection }, controlCallerId, callbacksDefinition, processor, eventOutputs, itemContext, }) => {
    if (!(0, valueIsArray_1.default)(collection) && !(0, valueIsRecord_1.default)(collection)) {
        executeProcesses(undefined, callbacks.onNonIterableCollection);
        return undefined;
    }
    const executeFunctions = (output) => (0, buildFunctionEvaluator_1.default)({
        processor,
        functionEntryVar: {
            source: 'computeFunction',
            process: callbacksDefinition === null || callbacksDefinition === void 0 ? void 0 : callbacksDefinition.onIteration,
        },
        controlCallerId,
        lastFunctionsOutputs: (0, writeFunctionOutputToRegistry_1.default)(lastFunctionsOutputs, functionId, output),
        itemContext,
        functionDefinitions,
        eventOutputs,
    });
    const onDone = (result) => executeProcesses(functionId, callbacks.onDone, result);
    const evaluatedValueIsValid = (itemRecord) => itemRecord.isValid === true;
    if ((0, valueIsArray_1.default)(collection)) {
        const newCollection = (await Promise.all(collection
            .map(async (item, itemIndex) => ({
            isValid: await executeFunctions({
                key: itemIndex,
                item,
                index: itemIndex,
            }),
            item,
        })))).filter(evaluatedValueIsValid).map((itemRecord) => itemRecord.item);
        onDone(newCollection);
        return newCollection;
    }
    const newRecordCollection = {};
    const collectionEntries = Object.entries(collection);
    const collectionRecords = (await Promise.all(collectionEntries
        .map(async ([key, item], itemIndex) => ({
        isValid: await executeFunctions({
            key: itemIndex,
            item,
            index: itemIndex,
        }),
        item,
        key,
    }))));
    collectionRecords.filter(evaluatedValueIsValid)
        .forEach((itemRecord) => {
        newRecordCollection[itemRecord.key] = itemRecord.item;
    });
    onDone(newRecordCollection);
    return newRecordCollection;
};
exports.default = buildCallableCollectionFilter;
